import apiServices from "../../../../../services/apiServices";
import eventBus from "../../../../main";
export default {
  state: {
    entityAvatar: {
      photo: ""
    }
  },
  mutations: {
    SET_E_AVATAR(state, value) {
      state.entityAvatar.photo = value.name;
    }
  },
  actions: {
    entityAvatars(context, avatar) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .getAvatarEntity(avatar)
        .then(function(response) {
          if (response.status === 200) {
            let obj = response.data;
            if (obj.code === 200 && obj.type === "success") {
              context.commit("SET_E_AVATAR", obj);
              let payload = {
                color: "success",
                text: "Fotografia de perfil carregada com sucesso",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            } else {
              let payload = {
                color: "error",
                text: "Ups! Pedido não processado",
                errorLogin: true
              };
              eventBus.$emit("openInfo", payload); // emit the event to the bus
            }
          } else {
            let payload = {
              color: "error",
              text: "Ups! Detectamos alguma incongruência",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {
          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload); // emit the event to the bus
        })
        .finally(function() {
          eventBus.$emit("openSpin", false); // emit the event to the bus
        });
    },

    entityProfileUpdate(context, profile) {
      eventBus.$emit("openSpin", true); // emit the event to the bus
      apiServices
        .updateProfileEntity(profile)
        .then(function(response) {
          if (response.status === 200) {
            let payload = {
              color: "success",
              text: "Dados actualizados com sucesso!",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          } else {
            let payload = {
              color: "error",
              text: "Ups! Seu pedido não foi processado",
              errorLogin: true
            };
            eventBus.$emit("openInfo", payload); // emit the event to the bus
          }
        })
        .catch(function() {
          let payload = {
            color: "error",
            text: "Ups! seu pedido não foi processado",
            errorLogin: true
          };
          eventBus.$emit("openInfo", payload);
        })
        .finally(function() {
          eventBus.$emit("openSpin", false);
        });
    }
  }
};
